import axios from 'axios';
import store from '@/store'; // <-- Importamos Vuex
// import router from '@/router';

const api = axios.create({
    baseURL: 'https://apiv2.videnti.co',
    withCredentials: true,
});

api.interceptors.request.use(
    (config) => {
        const token = store.state.auth.token; // <-- Leemos de Vuex
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

api.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;
        if (error.response?.status === 401 && error.response?.data?.code === 'TOKEN_EXPIRED' && !originalRequest._retry) {
            originalRequest._retry = true;
            try {
                // Llamamos a la acción de Vuex
                const newToken = await store.dispatch('auth/refreshToken');
                originalRequest.headers['Authorization'] = `Bearer ${newToken}`;
                return api(originalRequest);
            } catch (refreshError) {
                store.dispatch('auth/logout');
                // router.push('/login...');
                return Promise.reject(refreshError);
            }
        }
        return Promise.reject(error);
    }
);

export default api;